import { Component, OnInit,  Output, EventEmitter, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { FxEventEmitter } from "@Common/events";

@Component({
standalone: false,
  selector: 'footer-submit-cancel',
  templateUrl: './submit-cancel.component.html',
  styleUrls: ['./submit-cancel.component.css']
})
export class SubmitCancelComponent implements OnInit {
  @Output () submit = new FxEventEmitter ();
  @Output () cancel = new FxEventEmitter ();
  @Input() submitName = 'Submit';
  @Input() cancelName = 'Cancel';
  @ViewChild ('submit', {static: false}) submitButton;
  @ViewChild ('cancel', {static: false}) cancelButton;
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }
  ngAfterViewInit() {
    this.submitButton.text= this.submitName;
    this.cancelButton.text = this.cancelName;
    this.cdr.detectChanges();
  }
  onSubmit (evt) { this.submit.emit (evt); }
  onCancel (evt) { this.cancel.emit (evt); }

}
